#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"
#import "../../../graphql-wrappers/graphql/fragments/campaign-fragment.graphql"
#import "../../../graphql-wrappers/graphql/fragments/audience-fragment.graphql"

mutation CampaignSetOwner($input: CampaignSetOwnerInput!) {
    campaignSetOwner(input: $input) {
        campaign {
            ...CampaignFragment
            ... on Campaign {
                edition {
                    id
                    from {
                        ...FromAddress
                    }
                    audience {
                        ...AudienceFragment
                    }
                }
            }
        }
    }
}
